<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="9">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="add()"
              v-if="allow('A')"
              v-show="addButtonVisible"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}

export default {
  props: {
    // depRow: {
    //   type: Object,
    //   default: () => {},
    // },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      orgRow: {},
      addButtonVisible: true,
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    orgChange(row) {
      this.orgRow = row
      this.addButtonVisible = row.classLevel === 2
      this.query()
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', {
        ...this.form,
        materialCategoryCode: this.orgRow.materialCategoryCode,
        productLine: this.orgRow.productLine,
      })
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    add() {
      const { materialCategoryCode } = this.orgRow
      if (!materialCategoryCode) {
        this.$message.warning(
          this.$l('form_label_tip_category') || '请先选择一个分类！'
        )
        return
      }
      this.$emit('openEditFormDialog', { type: 'add' })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
